// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  runId: __t.string(),
  sourceName: __t.string(),
  fingerprint: __t.string(),
  specHash: __t.string(),
  durationMs: __t.u32(),
  models: __t.u32(),
  twinsCreated: __t.u32(),
  twinsUpdated: __t.u32(),
  relationships: __t.u32(),
  status: __t.string(),
  createdIdsJson: __t.string(),
  createdIdsTruncated: __t.bool(),
};
